import { Swiper } from "swiper";
import { Autoplay } from 'swiper/modules';
import { BREAKPOINT_SM, BREAKPOINT_MD, BREAKPOINT_LG } from "../globals";

const SLIDES_PER_VIEW_SM = 3;
const SLIDES_PER_VIEW_MD = 4;
const SLIDES_PER_VIEW_LG = 5;

export default class SliderAlbert {

	/**
	 * Initializes a certain slider and returns SliderAlbert as object
	 * @param {HTMLElement} swiperContainer 
	 * @returns {SliderAlbert} slider
	 */ 
	static init(swiperContainer) { 					
		return new SliderAlbert(swiperContainer);
	}
	/**
	 * Initializes each slider on the page and returns sliderAlbertInstances as a collection
	 * @param {HTMLElement} swiperContainer
	 * @returns {SliderAlbertInstances} collection of sliders
	 */
	static initAll() {
		const swiperContainers = document.querySelectorAll('.slider-albert');

		const sliderAlbertInstances = [];
		swiperContainers.forEach((swiperContainer) => {
			sliderAlbertInstances.push(SliderAlbert.init(swiperContainer));
		});

		return sliderAlbertInstances;
	}

	constructor(swiperContainer) {

		const swiperElement = swiperContainer.querySelector('.swiper');

		if (swiperElement === null) return;

		this.swiperDelay = swiperContainer.getAttribute('data-slider-delay');

		/** @var {SwiperOptions} */
		const config = {
			modules: [Autoplay],
			slidesPerView: 2,
			breakpoints: {
				[BREAKPOINT_SM]: {
					slidesPerView: SLIDES_PER_VIEW_SM,
				},
				[BREAKPOINT_MD]: {
					slidesPerView: SLIDES_PER_VIEW_MD,
				},
				[BREAKPOINT_LG]: {
					slidesPerView: SLIDES_PER_VIEW_LG,
				}
			},
			speed: 1000,
			autoplay: {
				delay: this.swiperDelay * 1000, // in miliseconds
				disableOnInteraction: false,
			},
			centerInsufficientSlides: true,
			grabCursor: true,
		};

		this.slider = new Swiper(swiperElement, config);
	}
}